module.exports = __webpack_public_path__ + "static/media/appLoggedIn.4e9c20d7.svg";